module.exports = __webpack_public_path__ + "img/rare-badge.64b4d26a.png";